import angular from 'angular'

import { SyncManager } from '../managers/sync-manager'

/**
 * Initialises the syncManager.
 *
 * @module webregister.resolvers.syncManagerResolver
 */
angular
  .module('webregister.resolvers')
  .factory('syncManagerResolver', function (syncManager: SyncManager) {
    return syncManager.init()
  })
